<template>
  <div class="sidebar-box">
    <div class="sidebar" @click="toggle">
      <app-icon type="iconwechat" class="icon-wechat"></app-icon>
    </div>
    <div class="sidebar-info" v-show="display">
      <div class="sidebar-info-item">
        <div class="sidebar-qr">
          <img width="90" height="90" src="https://sitecdn.zcycdn.com/zcy-front-other-upload/4894ac47563844d5df81ee7652e18a64.png?x-oss-process=image/quality,Q_75/format,jpg" alt="">
        </div>
        <strong>微信扫码关注</strong>
      </div>
      <app-icon class="icon-close" type="iconclose" @click="toggle"></app-icon>
    </div>
  </div>
</template>
<script>
import AppIcon from '@/components/icon';

export default {
  components: {
    'app-icon': AppIcon
  },
  data () {
    return {
      display: true
    };
  },
  methods: {
    toggle () {
      this.display = !this.display;
    }
  }
};
</script>

<style lang="less">
  .sidebar-box {
    position: fixed;
    right: 20px;
    bottom: 20px;
    .sidebar {
      width: 44px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #FFFFFF;
      border-radius: 2px;
      box-sizing: border-box;
      .icon-wechat {
        font-size: 20px;
      }
    }
    .sidebar-info {
      position: absolute;
      bottom: 0;
      left: -177px;
      box-sizing: border-box;
      width: 160px;
      height: 160px;
      padding: 27px 0 0 0;
      text-align: center;
      background: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 20px 0 rgba(0,0,0,0.10);
      &-item {
        text-align: center;
        strong {
          color: #333;
          font-size: 15px;
          font-weight: normal;
        }
        .sidebar-qr {
          height: 90px;
          margin-top: 8px;
        }
      }
      .icon-close {
        position: absolute;
        top: 12px;
        right: 12px;
        font-size: 15px;
        color: #979797;
        cursor: pointer;
      }
      &:after {
        content: '';
        display: block;
        width: 0;
        height: 0;
        position: absolute;
        bottom: 12px;
        right: -20px;
        border-top: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-left: 10px solid #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar/index.vue